<template>
	<div class="md-layout">
		<div class="md-layout-item md-medium-size-100 md-size-100">
			<h4>{{translate(locale.createProduct)}}</h4>
		</div>
		<div class="md-layout-item md-medium-size-100 md-size-100" v-if="!loaded">
			<md-card>
				<md-card-content>
					<loading />
				</md-card-content>
			</md-card>
		</div>

		<div class="md-layout-item md-medium-size-100 md-size-100" v-if="loaded">
			<md-card>
				<md-card-content>
					<div class="md-layout">
						<div class="md-layout-item md-xsmall-size-100 md-small-size-100 md-medium-size-100 md-size-60">
							<div class="md-layout">
								<div class="md-layout-item md-xsmall-size-100 md-small-size-100 md-medium-size-100 md-size-100">
									<h5>{{translate(locale.productInformation)}}</h5>
								</div>
								<div class="md-layout-item md-small-size-100 md-size-100 text-right">
									<span class="late">{{translate(locale.required)}}</span>
								</div>
								<div class="md-layout-item md-small-size-100 md-size-25">
									<form-select v-model="product.product_type_id" :list="product_type_list" :label="locale.productType"/>
								</div>
								<div class="md-layout-item md-xsmall-size-100 md-small-size-100 md-medium-size-100 md-size-75">
									<form-input v-model="product.name" :label="locale.productName"/>
								</div>
								<div class="md-layout-item md-small-size-100 md-size-50">
									<form-select v-model="product.product_category_id" :list="product_category_list" :label="locale.productCategory"/>
								</div>
								<div class="md-layout-item md-small-size-100 md-size-50">
									<form-select v-model="product.product_sub_category_id" :list="product_sub_category_filtered_list" :label="locale.productSubCategory"/>
								</div>
								<div class="md-layout-item md-small-size-100 md-size-50">
									<form-select v-model="product.product_price_type_id" :list="product_price_type_list" :label="locale.productPriceType"/>

								</div>
								<div class="md-layout-item md-small-size-100 md-size-50">
									<form-input v-model="product.price" :label="locale.productPrice" type="number" :disabled="product.product_price_type_id == 1"/>
								</div>
							
								<div class="md-layout-item md-xsmall-size-100 md-small-size-100 md-medium-size-100 md-size-100">
									<Editor style="height: 500px;width: 100%;border-radius: 5px;"
										v-model="product.content"
										api-key="ldywwz30g9zhdo7kgwt8jjimrbc7ypqozvkd0ur7vs8eg7uk"
										:init="editorConfig"/>
								</div>
								
							</div>
						</div>
						<div class="md-layout-item md-xsmall-size-100 md-small-size-100 md-medium-size-100 md-size-40">
							<div class="md-layout">
								<div class="md-layout-item md-xsmall-size-100 md-small-size-100 md-medium-size-100 md-size-100">
									<h5>{{translate(locale.productThumbnail)}}</h5>
									<div class="cover-image" @click="$refs.thumbnail.click()">
										<loading v-if="uploading"/>
										<span style="color: #999; text-align: center;" v-if="!uploading && String(product.image_cover_url).length == 0"><i class="material-icons">photo_camera</i><br>{{translate(locale.upload)}}</span>
										<img style="max-height: 200px; width: auto" :src="config.cdn + 'images/' + product.image_cover_url" alt="" v-if="!uploading && String(product.image_cover_url).length > 0">
										<input type="file" ref="thumbnail" accept="image/*" @change="handleCoverFile($event)" style="display: none" />
									</div>
								</div>
		
								<div class="md-layout-item md-xsmall-size-100 md-small-size-100 md-medium-size-100 md-size-100">
									<h5>{{translate(locale.productGallery)}}</h5>
									<input type="file" ref="gallery" accept="image/*" @change="handleGalleryFile($event)" style="display: none"/>
								</div>
		
								<div class="md-layout-item md-xsmall-size-100 md-small-size-33 md-medium-size-25 md-size-25" v-for="image in product.image_gallery_url">
									<div class="gallery-image">
										<img style="max-height: 200px; width: auto; cursor: pointer;" :src="config.cdn + 'images/' + image" @click="remove(image)"><br>
										<md-tooltip md-direction="bottom">{{translate(locale.deleteThis)}}</md-tooltip>
										<!-- <span style="color: #fab1a0; text-align: center; cursor: pointer; top: 0; right: 0"><i class="material-icons">delete</i></span> -->
									</div>
								</div>

								<div class="md-layout-item md-xsmall-size-100 md-small-size-33 md-medium-size-25 md-size-25" v-if="product.image_gallery_url.length < 10" v-for="(upload, i) in (8 - product.image_gallery_url.length)">
									<div  class="gallery-image-upload" style="cursor:pointer" @click="$refs.gallery.click()">
										<loading v-if="gallery_uploading && i == 0"/>
										<span style="color: #999; text-align: center;" v-else><i class="material-icons">photo_camera</i><br>{{translate(locale.upload)}}</span>
									</div>
								</div>
							</div>	
						</div>
						<div class="md-layout-item md-size-100 text-right">
							<span v-for="e in errors" style="color: red">* {{translate(e)}}<br></span>
						</div>
						<div class="md-layout-item md-xsmall-size-100 md-small-size-100 md-medium-size-100 md-size-100 text-right">
							<md-button class="md-raised md-primary" @click="createProduct()">{{translate(locale.createProduct)}}</md-button>
						</div>
					</div>
					
				</md-card-content>
			</md-card>
		</div>
	</div>
		
	</div>

</template>

<script>
	import Editor from '@tinymce/tinymce-vue';
	import { Datetime } from 'vue-datetime';
	export default {
		components: { Datetime, Editor },
		created() {
			this.getSettings();
		},

		data() {
			return {
				loaded: false,
				uploading: false,
				gallery_uploading: false,
				product: {
					name: "",
					content: "",
					product_type_id: "",
					price: "",
					product_price_type_id: "",
					product_category_id: "",
					product_sub_category_id: "",
					image_cover_url: "",
					image_gallery_url: []
				},
				product_type_list: [],
				product_price_type_list: [],
				product_category_list: [],
				product_sub_category_list: [],
				product_sub_category_filtered_list: [],
				editorConfig: {
					height: 500,
					menubar: false,
					plugins: 'lists link image table code help wordcount',
					toolbar: 'undo redo | fontfamily fontsize | formatselect bold italic forecolor backcolor | image table | lineheight alignleft aligncenter alignright alignjustify | numlist bullist outdent indent | removeformat| link code | help',
					font_family_formats: 'Arial=arial,helvetica,sans-serif; Courier New=courier new,courier,monospace; Moul=Moul; Siemreap=Siemreap; Hanuman=Hanuman;',
					automatic_uploads: true,
					images_upload_handler: this.handleEditorFile,
				},
				errors: []
			}
		},
		watch: {
			'product.product_category_id' : function(val) {
				this.product_sub_category_filtered_list = [];
				this.product.product_sub_category = "";
				this.product.product_sub_category_id = "";
				for(let i = 0; i< this.product_sub_category_list.length; i++) {
					if(this.product_sub_category_list[i].product_category_id == val) this.product_sub_category_filtered_list.push(this.product_sub_category_list[i]);
				}
			}
		},
		methods: {
			getSettings() {
				this.$http.get(this.config.api + "/profile/setting/product").then(data => {

					this.product_type_list = this.config.translateList(data.body.data.product_type, this.$store.state.l.lang);
					this.product_price_type_list = this.config.translateList(data.body.data.product_price_type, this.$store.state.l.lang);
					this.product_category_list = this.config.clearList(data.body.data.product_category, this.$store.state.l.lang);
					this.product_sub_category_list = this.config.clearList(data.body.data.product_sub_category, this.$store.state.l.lang);
					this.loaded = true;
				})
			},
			createProduct() {
				if(!this.checkValidation()) {
					this.$notification.notify({message: "Please fill in all required information.||សូមបំពេញព័ត៌មានឱ្យបានគ្រប់គ្រាន់។", icon: 'error', type: 'danger'});
					return;
				}

				this.$http.post(this.config.api + "/profile/product/post", {
					product: this.product
				}).then(res => {
					if(res.body.status == 'success') {
						this.$notification.notify({
							message: "You have created your product successfully.",
							icon: 'check_circle',
							type: 'success'
						});

						this.$router.push("/products_and_services");
					}
				})
			},
			handleEditorFile(blobInfo, success, failure) {

				const formData = new FormData();
				formData.append('file', blobInfo.blob(), blobInfo.filename());

				this.$http.post(this.config.api + "/profile/upload/image_content", formData).then(res => {
					if (res.body.status == 'success') {
						// this.activity.image_cover_url = res.body.data.image_hash;
						success(this.config.cdn + res.body.data.image_hash);
					} else {
						failure("Error uploading image.");
					}
				})
			},
			handleCoverFile(event) {
				if (!event.target.files.length) return;

				const formData = new FormData();
				formData.append('file', this.$refs.thumbnail.files[0]);
				this.uploading = true;
				this.$http.post(this.config.api + "/profile/upload/image_content", formData).then(res => {
					this.uploading = false;
					if (res.body.status == 'success') {
						this.product.image_cover_url = res.body.data.image_hash;
					}
				})
			},
			handleGalleryFile(event) {
				if (!event.target.files.length) return;

				const formData = new FormData();
				formData.append('file', this.$refs.gallery.files[0]);
				this.gallery_uploading = true;
				this.$http.post(this.config.api + "/profile/upload/image_content", formData).then(res => {
					this.gallery_uploading = false;
					if (res.body.status == 'success') {
						this.product.image_gallery_url.push(res.body.data.image_hash);
					}
				})
			},
			checkValidation() {
				this.errors = [];

				if(String(this.product.product_type_id).length <= 0) this.errors.push("Product/Service Type is empty.");
				if(String(this.product.name).length < 3) this.errors.push("Title is empty.");
				if(String(this.product.content).length < 3) this.errors.push("Content is empty.");
				if(String(this.product.product_price_type_id).length <= 0) this.errors.push("Product/Service Price Type is empty.");
				if(parseFloat(this.product.price) < 0) this.errors.push("Product Price is invalid.");
				if(String(this.product.product_sub_category_id).length <= 0) this.errors.push("Product/Service Sub-Category is empty.");

				if(this.errors.length == 0) return true;
				else return false;
			},
			remove(image){
				const index = this.product.image_gallery_url.indexOf(image);
				if (index > -1) this.product.image_gallery_url.splice(index, 1);
			},
		}
	}
</script>
<style scoped>
	.cover-image {
		border: 1px dashed #ccc; 
		min-height: 120px;
		/* margin-bottom: 8px;  */
		padding: 20px; 
		border-radius: 6px; 
		display: flex; 
		justify-content: center; 
		align-items: center; 
		cursor:pointer
	}
	.gallery-image {
		border: 1px dashed #ccc; 
		min-height: 120px; 
		margin-bottom: 8px;
		padding: 20px; 
		border-radius: 6px; 
		display: flex; 
		justify-content: center; 
		align-items: center
	}
	.gallery-image-upload {
		border: 1px dashed #ccc; 
		min-height: 120px;
		margin-bottom: 8px; 
		padding: 20px; 
		border-radius: 6px; 
		display: flex; 
		justify-content: center; 
		align-items: center
	}
	.product-thumbnail {
		width: 64px;
		height: 64px;
	}

	.grid-8 {
		text-align: center;
		max-width: 20%;
		min-width: 20%;
		flex: 0 0 20%;
	}

	.thumb-product {
		width: 50%;
	}
</style>


// WEBPACK FOOTER //
// src/pages/Products/New.vue